import type { PageHelpGuide } from './types.js';

/** Operator-only teaching copy; opening help never invokes a provider. */
export const AI_MONITORING_GUIDE: PageHelpGuide = {
  id: 'operator-ai-monitoring',
  title: 'پایش اتصال و سرویس‌های هوش مصنوعی',
  purpose:
    'می‌بینی هر سرویس چه تنظیماتی دارد و آخرین آزمون واقعی آن چه نتیجه‌ای داده است. آماده‌بودن تنظیمات به‌تنهایی سالم‌بودن اتصال را ثابت نمی‌کند.',
  example:
    'تنظیمات تحلیل تماس آماده است، اما هنوز آزمونی ثبت نشده؛ نتیجه «هنوز آزمون نشده» می‌ماند تا اپراتور مجاز، آزمون واقعی همان سرویس را تأیید کند.',
  steps: [
    'زمان گزارش، وضعیت تنظیمات و مدل درخواستی و نهاییِ تنظیم‌شدهٔ هر سرویس را بخوان؛ سرویس محلی را از اتصال خارجی جدا بدان.',
    'نتیجه و زمان آخرین آزمون را بررسی کن؛ نتیجهٔ قدیمی، نامشخص یا نبود آزمون به معنی اتصال سالم نیست.',
    'اگر مجوز داری و آزمون لازم است، فقط برای همان سرویس «آزمون واقعی» را بزن و توضیح هزینه را بخوان؛ سپس صریحاً تأیید کن.',
    'پس از آزمون، نتیجه، زمان پاسخ و مصرف گزارش‌شده را بررسی کن؛ برای دیدن وضعیت تازه، «تازه‌سازی گزارش» را بزن.',
  ],
  result:
    'می‌فهمی کدام مسیر به بررسی تنظیمات یا پیگیری خطا نیاز دارد؛ تازه‌سازی فقط گزارش را می‌خواند و هیچ سرویس را خودکار اصلاح یا آزمون نمی‌کند.',
  tips: [
    'آزمون واقعی ممکن است هزینهٔ کوچکی نزد ارائه‌دهنده داشته باشد؛ از کیف پول هیچ سازمانی کم نمی‌شود. هر تأیید فقط یک سرویس را می‌آزماید.',
    'توکن یا زمان پاسخِ گزارش‌نشده صفر نیست؛ موفقیت یک آزمون هم تضمین سلامت دائمی سرویس نیست. نتیجهٔ محلی، موفقیت اتصال خارجی محسوب نمی‌شود.',
    'اگر نتیجهٔ ارسال نامعلوم ماند، تلاش دوباره در همان پنجره همان درخواست را پیگیری می‌کند. پیش از شروع آزمون تازه، گزارش را بررسی کن.',
  ],
  flows: [
    {
      id: 'operator-ai-connection-review',
      title: 'از مشاهدهٔ وضعیت تا پیگیری اتصال',
      role: 'support',
      currentStepId: 'monitor',
      steps: [
        { id: 'configuration', label: 'تنظیم مسیر سرویس' },
        { id: 'monitor', label: 'بررسی گزارش پایش' },
        { id: 'probe', label: 'آزمون با تأیید اپراتور' },
        { id: 'review', label: 'بررسی پاسخ و علت خطا' },
        { id: 'followup', label: 'پیگیری و بازبینی نتیجه' },
      ],
      position:
        'این صفحه نقطهٔ بررسی تنظیمات و شواهد اتصال است؛ مراحل نقشه وضعیت زندهٔ هیچ سرویس یا درخواست مشخصی را اعلام نمی‌کنند.',
      before:
        'نشست و دسترسی مشاهدهٔ اپراتور لازم است؛ اجرای آزمون به مجوز مدیریت، تنظیمات قابل آزمون و رعایت فاصلهٔ مجاز نیاز دارد.',
      after:
        'با توجه به نتیجه، تنظیمات یا خطای سرویس از مسیر مجاز پیگیری می‌شود و سپس گزارش یا یک آزمون تأییدشده دوباره بررسی می‌شود.',
      note: 'بازکردن صفحه، راهنما یا تازه‌سازی گزارش هیچ آزمون واقعی اجرا نمی‌کند؛ آزمون هزینه‌دار فقط پس از تأیید صریح است.',
    },
  ],
};
